import { AuthLayout } from '@/components/global/AuthLayout';
import { store } from '@/store';
import { globalStyles } from '@/styles/stitches/global';
import isHexColor from '@/utils/isHexColor';
import { AppProps } from 'next/app';
import { Router, useRouter } from 'next/router';
import NProgress from 'nprogress';
import Modal from 'react-modal';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider as ReduxProvider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as yup from 'yup';

Router.events.on('routeChangeStart', () => {
  NProgress.start();
});

Router.events.on('routeChangeComplete', () => {
  NProgress.done();
});

Router.events.on('routeChangeError', () => {
  NProgress.done();
});

declare module 'yup' {
  interface StringSchema {
    hexColor(): StringSchema;
  }

  interface ObjectSchema<
    TIn extends yup.Maybe<yup.AnyObject>,
    TContext extends yup.AnyObject = yup.AnyObject,
    TDefault = any,
    TFlags extends yup.Flags = '',
    TType extends yup.Maybe<yup.AnyObject> = yup.AnyObject | undefined,
    TOut extends TType = TType,
  > extends yup.Schema<TType, TContext, TOut> {
    reactSelect(): ObjectSchema<{ label: string; value: string }, TContext>;
  }
}

yup.addMethod(yup.string, 'hexColor', function () {
  return this.test(`hexColor`, 'Cor inválida', function (value) {
    const result = isHexColor(value || '');
    return result;
  });
});

yup.addMethod(yup.object, 'reactSelect', function () {
  return this.shape({
    label: yup.string().required(''),
    value: yup.string().required(''),
  }).test(`reactSelect`, 'Selecione uma opção', function (value) {
    if (!value.value) return false;
    return true;
  });
});

export const queryClient = new QueryClient();

Modal.setAppElement('#__next');

globalStyles();

const PUBLIC_ROUTES = ['/', '/login', '/signup', '/pnld'];

function MyApp({ Component, pageProps }: AppProps) {
  const router = useRouter();
  const isPublic = PUBLIC_ROUTES.includes(router.pathname);

  return (
    <QueryClientProvider client={queryClient}>
      <ReduxProvider store={store}>
        <ToastContainer />

        {isPublic ? (
          <Component {...pageProps} />
        ) : (
          <AuthLayout>
            <Component {...pageProps} />
          </AuthLayout>
        )}
      </ReduxProvider>
    </QueryClientProvider>
  );
}

export default MyApp;
